import { createSvgComponent } from "../../icon/createSvgComponent";
import Instagram from "@core/__generated__/icon/figma/instagram.svg";
export default createSvgComponent(Instagram);